(function() {
	'use strict';

	angular.module('services')
	.service('dashboardRedirectService', dashboardRedirectService);

	function dashboardRedirectService($http, $state, $location,
			URLS, navigationService, leanFilterService,
			dashboardCreationService) {
		var dashboards = [];

		return {
			getDashboard: getDashboard,
			createDashboard: createDashboard
		};

		function getDashboard(dashboardName) {
			var url = '2/factndx/' + globalConfig.factory.id + '/ReportSettings/BaseReportName/buyer-performance?viewType=dashboards&type=customer';
			return $http.get(URLS.host + url)
				.then(getDashboardComplete)
				.catch(getDashboardFailed);

			function getDashboardComplete(response) {
				if (response && response.data) {
					return response.data.reportSettingsId;
				}
				return null;
			}

			function getDashboardFailed(error) {
				return null;
			}
		}

		function loadDashboards() {
			return $http.get(String.format(URLS.dashboards, globalConfig.customer.id)).then(
				function (response) {
					dashboards = response.data;
				},
				function (error) { }
			);
		}

		function createDashboard(dashboardData) {
			if (!dashboards || !dashboards.length) {
				loadDashboards().then(function() {
					createDashboardInner(dashboardData);
				});
			} else {
				createDashboardInner(dashboardData);
			}
		}

		function createDashboardInner(dashboardData) {
			var baseReportName = dashboardData.parentName;
			var drilldownFilters = dashboardData.drilldownSettings && dashboardData.drilldownSettings.filters ? dashboardData.drilldownSettings.filters : null;
			var drilldownSorters = dashboardData.drilldownSettings && dashboardData.drilldownSettings.sorters ? dashboardData.drilldownSettings.sorters : null;
			var dashboard = _.find(dashboards, {baseReportName: baseReportName});
			if (!dashboard) {
				 return;
			}
			var isXMatrix = dashboard.name === 'X-matrix';
			var defaultFactoryFilter = !isXMatrix ? leanFilterService.leanDnaAllSelected : globalConfig.factory.id;

			var newDashboard = {
				reportName: dashboard.name,
				baseReportName: dashboard.baseReportName,
				filters: drilldownFilters ? drilldownFilters : [{id: 'factory', values: [defaultFactoryFilter]}],
				columns: [],
				recordsPerPage: 0,
				viewType: 'dashboards',
				type: 'customer',
				userModified: true,
				search: '',
				config: dashboard.config ? JSON.parse(dashboard.config) : {},
				sorters: drilldownSorters ? drilldownSorters : []
			};

			dashboardCreationService.createDashboard(newDashboard, createDashboardCallback);

			function createDashboardCallback(response, newDashboard) {
				pendo.track('addDashboard', {
					name: newDashboard.reportName,
					parentName: newDashboard.baseReportName,
					structure: newDashboard.config.layout
				});

				if (response && response.data && response.data.ndx) {
					$state.go('app.dashboard.home', {id:response.data.ndx});
				}
			}
		}
	}
})();
